import GuidelinesContainer from "./GuidelinesContainer";

export default GuidelinesContainer;
